var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.images),function(img,index){return _c('div',{key:index},[(_vm.useCanvas)?_c('PrintCanvas',{class:_vm.paper,attrs:{"id":"print-area","sourceImage":img.image,"zoom":img.zoom,"centerx":img.centerx,"centery":img.centery}}):_c('BrowseImage',{attrs:{"imageUrl":img,"paper":_vm.paper,"descText":_vm.descText}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }